module.exports = __webpack_public_path__ + "media/images/vector/vector_1-856bfc3a2d198d27625061468cf66324.svg";